export default function authHeader() {
  let user = JSON.parse(localStorage.getItem('user_free'));
  if (user) {
    return {
      Authorization: 'Bearer ' + user,
      'Accept': "application/json",
      "Content-Type": "application/json",
    };
  } else {
    return {};
  }
}